import React, { useEffect, useState } from 'react';
import './Template.scss';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill/dist/quill.snow.css'
 import { IoMdArrowBack } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';


function Template() {

   const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;
      
       const navigate = useNavigate("")
         const [templates, setTemplates] = useState([]);
        const [researcherId, setResearcherId] = useState();
        const location = useLocation();


  // const [currentPage, setCurrentPage] = useState(1);
  //   const rowsPerPage = 5;
  
    
  //   const indexOfLastRow = currentPage * rowsPerPage;
  //   const indexOfFirstRow = indexOfLastRow - rowsPerPage;
   
  
    
  
  //    const nextPage = () => {
  //     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  //   };
  
  //   const prevPage = () => {
  //     if (currentPage > 1) setCurrentPage(currentPage - 1);
  //   };

  const handleBack = () => {
    if (location.state?.from === "dashboard") {
      navigate("/mail");
    } else {
      navigate("/campaign");
    }
  };
  
  
    useEffect(() => {
      const fetchResearcherId = async () => {
        try {
          const response = await axios.get(`${baseURL}/api/get-researcherid`);
          setResearcherId(response.data.researcherId);
        } catch (err) {
         Swal.fire({
                   icon: 'error',
                   title: 'Error',
                   text: 'Something went wrong!',
                   confirmButtonColor: 'red',
                 });
        }
      };
  
      fetchResearcherId();
    }, []);

 useEffect(() => {
  const fetchTemplates = async () => {
    if (!researcherId) return; 

    try {
     const response = await axios.get(`${baseURL}/api/get-researcher-templates`, {
        params: { researcherId }, 
        headers: {
          "Content-Type": "application/json",
        },
      });
      setTemplates(response.data || []);
    } catch (err) {
     Swal.fire({
               icon: 'error',
               title: 'Error',
               text: 'Something went wrong!',
               confirmButtonColor: 'red',
             });
    }
  };

  fetchTemplates();
}, [researcherId]);

const handleUseTemplate = (template) => {
    navigate("/campaign", { state: { selectedTemplate: template } });
  };

    
  return (
    <div className='email-form-container'>
       <div className='email-campaign'>
                <div className='campaign'> <IoMdArrowBack style={{fontSize:"25px", cursor:"pointer"}}
                 onClick={handleBack} />Template Library </div>  
              </div>
      <div className="campaign-tablepagination">
          <table className="campaign-table">
            <thead>
              <tr>
                <th><input type="checkbox" /></th>
                <th>Template Name</th>
                <th>Preview</th>
                <th>Action</th>
              </tr>
            </thead>
           <tbody>
  {templates.length > 0 ? (
    templates.map((template, index) => (
      <tr key={index}>
        <td>
          <input type="checkbox" />
        </td>
        <td>{template.name}</td>
        <td>{template.message.length> 20 ? `${template.message.slice(0,50)}...`:template.message}</td>
        <td>
          <button className='use-temp-btn' onClick={() => handleUseTemplate(template)}>Use Template</button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4">No templates available</td>
    </tr>
  )}
</tbody>

          </table>
          {/* <div style={{ marginTop: "20px" }} className='table-pagination'>
            <button onClick={prevPage} disabled={currentPage === 1} className="nav-button">
              Prev
            </button>
            <span style={{ margin: "0 10px" }}>
              Page {currentPage} of {totalPages}
            </span>
            <button onClick={nextPage} disabled={currentPage === totalPages} className="nav-button">
              Next
            </button>
          </div> */}
        </div>
    </div>
  )
}

export default Template
